import styled from "styled-components";

export const MainHeader = styled.div`
  flex-direction: row;
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #E5E7EB;
`;


export const Content = styled.div`
  flex: 1;
  min-width: 0; /* importante para quebra de texto */
`;